import Link from 'next/link';
import { useRouter } from 'next/router';
import { FC } from 'react';
import useGTAG, { GTAGPrefix } from 'src/hooks/useGTAG';
import { Locales } from 'src/utils/localization';

interface Props {
  gtagPrefix?: GTAGPrefix;
}

const LangSwitcher: FC<Props> = ({ gtagPrefix }) => {
  const router = useRouter();
  const { trackGtagEvent } = useGTAG();

  const handleLanguageChange = () => {
    trackGtagEvent(`${gtagPrefix}_language`);
    if (router.asPath) {
      trackGtagEvent(`${gtagPrefix}_language_changed`);
    }
  };

  return (
    <span className="fs-caption-reg text-gray900">
      {router.locale === Locales.UA && (
        <Link
          onClick={handleLanguageChange}
          href={router.asPath}
          passHref
          prefetch={false}
          locale={Locales.UA}
          role="link"
        >
          <span>UA</span>
        </Link>
      )}
    </span>
  );
};

export default LangSwitcher;
